export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AM-051ba42b17a355eef367450ec139c9fb.png";